import { render, staticRenderFns } from "./postdoctorInfo.vue?vue&type=template&id=bc25c438&scoped=true&"
import script from "./postdoctorInfo.vue?vue&type=script&lang=js&"
export * from "./postdoctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorInfo.vue?vue&type=style&index=0&id=bc25c438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc25c438",
  null
  
)

export default component.exports